import type { ViewerContext_UserFragment } from './ViewerContext.generated';

type Role = 'logged-out' | 'customer' | 'designer' | 'admin';

export function getViewerRole(user: ViewerContext_UserFragment | null): Role {
    if (!user) {
        return 'logged-out';
    } else if (user.isAdmin) {
        return 'admin';
    } else if (user.isDesigner) {
        return 'designer';
    } else {
        return 'customer';
    }
}
